/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SupportWidgetFormEl} from 'iron/routes/global-sidenav/widgets/support-widget/support-widget-form';
import {ModalEl} from 'common/components/modal';
import type {SupportWidget} from 'iron/routes/global-sidenav/widgets/support-widget/index';

export function template(this: SupportWidget) {
  const {isMaximized} = this.state;

  const formEl = (
    <SupportWidgetFormEl
      attrs={this.helpers.getFormAttributes()}
      on={{
        close: this.helpers.handleSupportWidgetClosed,
        dock: this.helpers.handleSupportWidgetUnmaximized,
        maximize: this.helpers.handleSupportWidgetMaximized,
        'state-change': this.helpers.handleFormStateChange,
      }}
    />
  );

  return (
    <div sel='.support-widget-container'>
      <ModalEl
        attrs={{
          closeable: false,
          'grow-to-content': true,
          'hide-close-button': true,
          open: isMaximized,
          'style-override': `.mp-modal-main { background: none !important; box-shadow: none !important; }`,
        }}
      >
        {isMaximized ? formEl : null}
      </ModalEl>
      {!isMaximized ? formEl : null}
    </div>
  );
}
